<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M7.714 4a.857.857 0 00-.857.857v2h-2a.857.857 0 000 1.714h2v15.143c0 .79.64 1.429 1.429 1.429h15.143v2a.857.857 0 001.714 0v-2h2a.857.857 0 000-1.714H8.57V4.857A.857.857 0 007.714 4z"/><path d="M18.696 15.049l3.018 3.018v2.424l-4.028-4.028-5.252 5.251h-2.148v-.275l6.39-6.39a1.429 1.429 0 012.02 0z"/><path d="M10.286 6.857v1.714h13.143v13.143h1.714V8.286c0-.79-.64-1.429-1.429-1.429H10.286z"/><path fill-rule="evenodd" d="M15.429 12.857a2.572 2.572 0 11-5.143 0 2.572 2.572 0 015.143 0zm-1.715 0a.857.857 0 11-1.714 0 .857.857 0 011.714 0z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'mediaImageExpandedOutline'
}
</script>
